import BotProfil from "/src/features/botProfil/BotProfil";
import useBotProfiles from "/src/features/botProfil/hooks/useBotProfiles";
import { PageTable, Header } from "/src/layouts/page";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import exportBotProfilPdf from "/src/features/botProfil/services/exportBotProfilPdf";
import storage from "/src/utils/storage";

function BotProfilPage() {
    const { bots, loading } = useBotProfiles();
    const company = storage("session").get("company");
    const companyName = company ? company.name : "";

    return (
        <PageTable>
            <Header title={companyName}>
                <IconButton
                    onClick={() => exportBotProfilPdf(companyName, bots)}
                    className="icons_up main-iconButton profil_action main_add-button space_tableButton"
                    icon="fas fa-file-pdf"
                    title="Export as PDF"
                ></IconButton>
            </Header>
            <BotProfil bots={bots} loading={loading} companyName={companyName} />
        </PageTable>
    );
}

export default BotProfilPage;
